<template>
  <div class="alert" :class="`alert--${level}`">
    <div class="alert-content" v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'AlertMessage',
  components: {},
  props: {
    text: {
      type: String,
      default: '',
    },
    level: {
      type: String,
      validator(value) {
        return ['error', 'warning', 'allgood'].includes(value)
      },
      default: 'error',
    },
  },
}
</script>

<style lang="postcss" scoped>
.alert {
  display: flex;
  padding: 10px;
  margin-bottom: 5px;
  flex-shrink: 1;
  flex-grow: 1;
  flex-basis: auto;
  font-weight: 400;
  font-style: normal;
  font-size: 15px;
  line-height: 1.35;
  color: var(--c-primary-neutral-1);

  >>> a {
    font-size: inherit;
  }
}

.alert-content {
  margin: auto 0;
}

.alert--warning {
  background-color: var(--c-secondary-color-4);
}

.alert--error {
  background-color: var(--c-secondary-color-1);
  color: var(--c-primary-neutral-3);
}

.alert--allgood {
  background-color: var(--c-primary-color-1);
  color: var(--c-primary-neutral-3);
}
@media (--md) {
  .alert {
    font-size: 13px;
  }
}
</style>
